/* eslint-disable no-console */

import React, { useRef } from 'react';
import Clipboard from 'clipboard';
import { Button } from '@/components/ui/Buttons';
import Icon, { ValidIcon } from '@/components/ui/Icon';
import showToast from '@/components/common/Toast';
import clsx from 'clsx';

interface CopyToClipboardButtonProps {
  className?: string;
  errorMessage: string;
  iconName?: ValidIcon;
  successMessage: string;
  text: string;
  useIcon: boolean;
}

const CopyToClipboardButton = ({
  className,
  errorMessage,
  iconName,
  successMessage,
  text,
  useIcon = false,
}: CopyToClipboardButtonProps) => {
  const buttonRef = useRef(null);
  const icon = iconName ? <Icon icon={iconName} size={16} /> : <i className="fa fa-copy" />;
  const buttonClassName = clsx(
    className,
    { 'tw-p-0 tw-flex tw-items-center tw-justify-center': iconName },
  );

  const copyToClipboard = () => {
    const clipboard = new Clipboard(buttonRef.current, {
      text: () => text,
    });

    clipboard.on('success', () => {
      showToast(successMessage, { autoClose: 4000 });
      clipboard.destroy();
    });

    clipboard.on('error', () => {
      showToast(errorMessage, { autoClose: 4000, msgType: 'error' });
      clipboard.destroy();
    });

    clipboard.onClick({ currentTarget: buttonRef.current });
  };

  return (
    <Button
      className={buttonClassName}
      onClick={copyToClipboard}
      buttonRef={buttonRef}
      outlineStyle
      small
    >
      {useIcon ? icon : 'Copy'}
    </Button>
  );
};

export default CopyToClipboardButton;
